/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import styles from './MonitoringFeed.module.scss';

type Severity = 'hi' | 'md' | 'lo' | 'info';

type FeedEvent = {
  severity: Severity;
  title: string;
  subtitle: string;
  time: string;
};

const EVENTS: FeedEvent[] = [
  {
    severity: 'hi',
    title: 'Ownership change detected',
    subtitle: 'Northgate Castings · new 30% shareholder',
    time: '2m ago',
  },
  { severity: 'md', title: 'Accounts overdue', subtitle: 'Anvil Precision BV · filing 21 days late', time: '1h ago' },
  {
    severity: 'lo',
    title: 'Sanctions list refresh — no match',
    subtitle: 'Meridian Components · owners re-screened',
    time: '4h ago',
  },
  {
    severity: 'info',
    title: 'Registered address changed',
    subtitle: 'Meridian Components · new principal office',
    time: '9h ago',
  },
  { severity: 'md', title: 'New director appointed', subtitle: 'Halberd Group Holdings · UBO change', time: '1d ago' },
  {
    severity: 'md',
    title: 'New charge registered',
    subtitle: 'Northgate Castings · secured lender added',
    time: '2d ago',
  },
];

export const MonitoringFeed = () => (
  <div className={styles.feed}>
    <div className={styles.head}>
      Change feed · Supplier base
      <span className={styles.live}>
        <span className={styles.liveDot} />
        Live
      </span>
    </div>

    <div className={styles.viewport}>
      <div className={styles.track} aria-hidden="true">
        {[...EVENTS, ...EVENTS].map((ev, i) => (
          <div key={i} className={styles.event}>
            <span className={cn(styles.dot, styles[ev.severity])} />
            <div className={styles.text}>
              <b>{ev.title}</b>
              <span>{ev.subtitle}</span>
            </div>
            <span className={styles.time}>{ev.time}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);
